import React, { useEffect } from "react";
import {
  Grid,
  TextField,
} from "@material-ui/core";
import { Breadcrumb } from "components/breadCrumb";
import { SearchButton } from "components/searchButton";
import { ReactComponent as SearchIcon } from "assets/icons/search-white.svg";
import {
  MoreAccessedService,
  MoreAccessedServiceDescription,
  MoreAccessedServiceTitle,
} from "components/servicesContainer";
import { PageTitle } from "components/pageTitle";
import { Wrapper } from "components/wrapper";
import { useServicesState } from "./context/services-context";
import { useServicesController } from "./context/services-controller";
import { ILinkServicesListResponse } from "models/response/link-services-list-response";
import CustomBackdrop from "components/backdrop";

export const ServicesPage = () => {
  const { linkServicesRequest, linkServicesResponse, loading } = useServicesState();
  const { onInit, handleOnChange, listLinkServices, convertIcon } = useServicesController();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    (async () => {
      await onInit();

    })();

  }, []);

  return (
    <>
      <Breadcrumb
        items={[
          { label: "Home", href: "/" },
          { label: "Serviços" },
        ]}
      />
      <PageTitle>SERVIÇOS</PageTitle>
      <Wrapper>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs>
                <TextField
                  variant="outlined"
                  name="text-field-term"
                  label="Título ou descrição"
                  value={linkServicesRequest?.term}
                  onChange={(e) => handleOnChange(e)}
                  fullWidth
                />
              </Grid>
              <Grid item xs="auto">
                <SearchButton onClick={() => (async () => {
                  await listLinkServices(linkServicesRequest);

                })()}>
                  <SearchIcon />
                  Consultar
                </SearchButton>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <CustomBackdrop open={loading} />
            <Grid container spacing={2}>
              {linkServicesResponse?.map((service: ILinkServicesListResponse) => (
                <Grid item xs={12} md={6} lg={3}>
                  <MoreAccessedService key={service.title} onClick={() => window.open(service.url, "_blank")}>
                    <img src={convertIcon(service.icon)} alt={service.title} />
                    <div>
                      <MoreAccessedServiceTitle>
                        {service.title}
                      </MoreAccessedServiceTitle>
                      <MoreAccessedServiceDescription>
                        {service.subtitle}
                      </MoreAccessedServiceDescription>
                    </div>
                  </MoreAccessedService>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Wrapper>
    </>
  );
};
